var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-list',_vm._l((_vm.laboratories),function(laboratory,i){return _c('v-list-item',{key:i,attrs:{"link":""},on:{"click":function($event){return _vm.$emit('click', laboratory)}}},[_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"laboratory-name",domProps:{"textContent":_vm._s(laboratory.name)}})],1)],1)}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }